import { useQuery } from '@tanstack/react-query';
import { api, GrLeaderboardResult } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';

interface UseLeaderboardReturn {
  data: GrLeaderboardResult | null;
  loading: boolean;
  error: string | null;
  refresh: () => void;
}

export function useLeaderboard(
  gameConfigId: string | null,
  gameEvent: string | null,
): UseLeaderboardReturn {
  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: queryKeys.gameRewards.leaderboard(gameConfigId!, gameEvent!),
    queryFn: () => api.getGameRewardsLeaderboard(gameConfigId!, gameEvent!),
    enabled: !!gameConfigId && !!gameEvent,
  });

  return {
    data: data ?? null,
    loading: isLoading,
    error: error instanceof Error ? error.message : isError ? 'Failed to load leaderboard' : null,
    refresh: () => {
      refetch();
    },
  };
}
